import { render, staticRenderFns } from "./BannerFilterDefaultLayout.vue?vue&type=template&id=cc45a6a8&scoped=true&"
import script from "./BannerFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BannerFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc45a6a8",
  null
  
)

export default component.exports